import { Link, useParams } from "react-router-dom";
import Product from "./Product";
import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ScrollToTopOnMount from "../template/ScrollToTopOnMount";
import { PRD_LIST } from "../data/products";
import Pagination from "../template/Pagination";

const categories = [
  "All Products",
  "Hàng rào",
  "Cửa",
  "Lan Can",
  "Khung Bảo Vệ",
  "Cầu Thang",
  "Nhà xe"
];


const allProducts = PRD_LIST;

const models = [
  { id: "1", name: "Sắt" },
  { id: "2", name: "Inox" },
  { id: "3", name: "Nhôm" },
];

const manufacturers = ["An Phát", "Thịnh Phát", "Duy Phát", "Hưng Phát", "Hoàng Phát"];

function FilterMenuLeft({
  categories, selectedCategory, setSelectedBrands,
  selectedManufacturers, setSelectedManufacturers,
  minPrice, setMinPrice, maxPrice, setMaxPrice
}) {


  function toggleManufacturer(manu) {
    setSelectedManufacturers((prev) =>
      prev.includes(manu) ? prev.filter((m) => m !== manu) : [...prev, manu]
    );
  }

  return (
    <ul className="list-group list-group-flush rounded">
      <li className="list-group-item d-none d-lg-block">
        <h5 className="mt-1 mb-2">Browse</h5>
        <div className="d-flex flex-wrap my-2">
          {categories.map((v, i) => {
            const url = v === "All Products"
              ? "/products"
              : `/products/category/${encodeURIComponent(v)}`;
            const active = selectedCategory === v;
            return (
              <Link
                key={i}
                to={url}
                className={`btn btn-sm rounded-pill me-2 mb-2 ${active ? "btn-dark" : "btn-outline-dark"}`}
              >
                {v}
              </Link>
            );
          })}
        </div>

      </li>
      <li className="list-group-item">
        <h5 className="mt-1 mb-1">Manufacturers</h5>
        <div className="d-flex flex-column">
          {manufacturers.map((v, i) => (
            <div key={i} className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={selectedManufacturers.includes(v)}
                onChange={() => toggleManufacturer(v)}
              />
              <label className="form-check-label">{v}</label>
            </div>
          ))}
        </div>
      </li>
      <li className="list-group-item">
        <h5 className="mt-1 mb-2">Price Range</h5>
        <div className="d-grid d-block mb-3">
          <div className="form-floating mb-2">
            <input
              type="number"
              className="form-control"
              placeholder="Min"
              value={minPrice}
              onChange={(e) => setMinPrice(e.target.value)}
            />
            <label>Min Price</label>
          </div>
          <div className="form-floating mb-2">
            <input
              type="number"
              className="form-control"
              placeholder="Max"
              value={maxPrice}
              onChange={(e) => setMaxPrice(e.target.value)}
            />
            <label>Max Price</label>
          </div>
        </div>
      </li>
    </ul>
  );
}

function ProductList() {
  const [viewType, setViewType] = useState({ grid: true });
  const [products, setProducts] = useState([]);
  const [selectedModel, setSelectedModel] = useState("");
  const { category } = useParams();
  const currentCategory = category ? decodeURIComponent(category) : "All Products";
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedManufacturers, setSelectedManufacturers] = useState([]);
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All Products");
  const [searchTerm, setSearchTerm] = useState("");



  useEffect(() => {
    setSelectedCategory(currentCategory);
  }, [currentCategory]);

  useEffect(() => {
    setProducts(allProducts);
  }, []);



  const filteredProducts = products.filter((p) => {
    const matchSearch =
      !searchTerm ||
      p.name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchModel = selectedModel ? p.model === selectedModel : true;
    const matchCategory =
      selectedCategory === "All Products" || p.category === selectedCategory;

    const matchBrand =
      selectedBrands.length === 0 || selectedBrands.includes(p.brand);

    const matchManufacturer =
      selectedManufacturers.length === 0 ||
      selectedManufacturers.includes(p.manufacturer);

    const matchPrice =
      (!minPrice || p.price >= Number(minPrice)) &&
      (!maxPrice || p.price <= Number(maxPrice));

    return matchModel && matchCategory && matchBrand && matchManufacturer && matchPrice && matchSearch;
  });
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(9); // tương ứng grid = true

  
  const totalItems = filteredProducts.length;

  const start = (page - 1) * itemsPerPage;
  const paginatedProducts = filteredProducts.slice(start, start + itemsPerPage);
  useEffect(() => {
    setPage(1);
  }, [currentCategory, selectedModel, selectedBrands, selectedManufacturers, minPrice, maxPrice, searchTerm]);
  useEffect(() => {
    const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
    if (page > totalPages) setPage(totalPages);
  }, [totalItems, itemsPerPage, page]);

  function changeViewType() {
    setViewType(prev => {
      const newGrid = !prev.grid;
      setItemsPerPage(newGrid ? 9 : 10);
      return { grid: newGrid };
    });
  }


  return (
    <div className="container mt-5 py-4 px-xl-5">
      <ScrollToTopOnMount />

      <nav aria-label="breadcrumb" className="bg-custom-light rounded">
        <ol className="breadcrumb p-3 mb-0">
          {category ? (
            <>
              <li className="breadcrumb-item">
                <Link to="/products" className="text-decoration-none link-secondary">
                  All Products
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                {currentCategory}
              </li>
            </>
          ) : (
            <li className="breadcrumb-item active" aria-current="page">
              All Products
            </li>
          )}
        </ol>
      </nav>


      <h2>{currentCategory}</h2>
      <div className="h-scroller d-block d-lg-none">
        <nav className="nav h-underline">
          {categories.map((v, i) => {
            const urlCategory = v === "All Products"
              ? "/products"
              : `/products/category/${encodeURIComponent(v)}`;
            return (
              <div key={i} className="h-link me-2">
                <Link
                  to={urlCategory}
                  className="btn btn-sm btn-outline-dark rounded-pill"
                  onClick={() => console.log("Đi tới:", urlCategory)}
                >
                  {v}
                </Link>
              </div>
            );
          })}
        </nav>
      </div>

      <div className="row mb-3 d-block d-lg-none">
        <div className="col-12">
          <div id="accordionFilter" className="accordion shadow-sm">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingOne">
                <button
                  className="accordion-button fw-bold collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFilter"
                  aria-expanded="false"
                  aria-controls="collapseFilter"
                >
                  Filter Products
                </button>
              </h2>
            </div>
            <div
              id="collapseFilter"
              className="accordion-collapse collapse"
              data-bs-parent="#accordionFilter"
            >
              <FilterMenuLeft
                categories={categories}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                selectedManufacturers={selectedManufacturers}
                setSelectedManufacturers={setSelectedManufacturers}
                minPrice={minPrice}
                setMinPrice={setMinPrice}
                maxPrice={maxPrice}
                setMaxPrice={setMaxPrice}
              />

            </div>
          </div>
        </div>
      </div>

      <div className="row mb-4 mt-lg-3">
        <div className="d-none d-lg-block col-lg-3">
          <div className="border rounded shadow-sm">
            <FilterMenuLeft
              categories={categories}
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
              selectedBrands={selectedBrands}
              setSelectedBrands={setSelectedBrands}
              selectedManufacturers={selectedManufacturers}
              setSelectedManufacturers={setSelectedManufacturers}
              minPrice={minPrice}
              setMinPrice={setMinPrice}
              maxPrice={maxPrice}
              setMaxPrice={setMaxPrice}
            />

          </div>
        </div>
        <div className="col-lg-9">
          <div className="d-flex flex-column h-100">
            <div className="row mb-3">
              <div className="col-lg-3 d-none d-lg-block">
                <select
                  className="form-select"
                  value={selectedModel}
                  onChange={(e) => setSelectedModel(e.target.value)}
                >
                  <option value="">All types</option>
                  {models.map((m) => (
                    <option key={m.id} value={m.id}>
                      {m.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-lg-9 col-xl-5 offset-xl-4 d-flex flex-row">
                <div className="input-group">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Search products..."
                    aria-label="search input"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <button className="btn btn-outline-dark">
                    <FontAwesomeIcon icon={["fas", "search"]} />
                  </button>
                </div>
                <button
                  className="btn btn-outline-dark ms-2 d-none d-lg-inline"
                  onClick={changeViewType}
                >
                  <FontAwesomeIcon
                    icon={["fas", viewType.grid ? "th-list" : "th-large"]}
                  />
                </button>
              </div>
            </div>
            <div
              className={
                "row row-cols-1 row-cols-md-2 row-cols-lg-2 g-3 mb-4 flex-shrink-0 " +
                (viewType.grid ? "row-cols-xl-3" : "row-cols-xl-2")
              }
            >
              {paginatedProducts.map((product) => (
                <Product
                  key={product.id}
                  id={product.id}
                  name={product.name}
                  image={product.image}
                  price={product.price}
                  percentOff={product.percentOff}
                />
              ))}

            </div>
            <Pagination
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              currentPage={page}
              onPageChange={setPage}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductList;
